export enum LoadStatus {
    INITIAL_STATE,
    PENDING,
    LOADED,
    ERROR,
}
